import { LoadingOverlay } from 'modules/workflows/components/LoadingOverlay';
import styled from 'styled-components';
import { Tab } from 'ui/tabs';
import { body2, colors, fontSizes, fontWeights, spacing, zIndex } from 'ui/theme';
import { normalPageMaxWidthWithMargin } from 'ui/theme/spacing';
import { pxToRem } from 'utils/convert';
import { PageContainer } from '../CommonStyled';

const customSpacing = {
  p2: pxToRem(2),
  p3: pxToRem(3),
  p18: pxToRem(18),
  p20: pxToRem(20),
  p22: pxToRem(22),
  p40: pxToRem(40),
};

export const FullWidthPageContainer = styled(PageContainer)`
  margin: -${customSpacing.p20} -${customSpacing.p40} -${customSpacing.p20};
`;

export const ContentWrapper = styled.div`
  max-width: ${normalPageMaxWidthWithMargin};
  padding: 0 ${spacing.double};
  margin: 0 auto;
`;

export const PageHeaderSection = styled.div`
  background-color: ${colors.grey1};
`;

export const PageBodySection = styled(ContentWrapper)`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const TabHeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${spacing.x4};
  border-bottom: ${spacing.single} solid ${colors.grey10};
`;

export const StyledTab = styled(Tab)`
  border-bottom: none;
  padding: ${customSpacing.p22};
  & span {
    ${body2};
    padding-bottom: ${customSpacing.p18};
    color: ${({ isSelected }) => (isSelected ? colors.purple90 : colors.textSecondary)};
    border-bottom: ${({ isSelected }) =>
      isSelected ? `${spacing.quarter} solid ${colors.purple90}` : 'none'};
  }
`;

export const HelperTextSection = styled.div`
  ${body2};
  display: flex;
  gap: ${spacing.half};
  color: ${colors.textPrimary};
`;

export const StyledLink = styled.a`
  display: flex;
  align-items: center;
  font-weight: ${fontWeights.bold};
  color: ${colors.textLink};
  :hover {
    color: ${colors.textLink};
  }
`;

export const TabBodySection = styled.div`
  margin: ${spacing.double} 0;
`;

export const ExperimentDetailsContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.secondaryText};
  size: ${fontSizes.s12};
  white-space: pre;
`;

export const Detail = styled.div`
  display: flex;
  align-items: center;
  white-space: pre;
  &:not(:last-child):after {
    padding: 0 ${spacing.half};
    content: '•';
    color: ${colors.grey35};
  }

  &:last-child {
    padding-right: 0;
  }

  svg {
    margin-right: ${customSpacing.p2};
  }
`;

export const PrimaryDetail = styled(Detail)`
  color: ${colors.grey80};
`;

export const Bold = styled.b`
  font-weight: ${fontWeights.bold};
  cursor: pointer;
`;

export const BoldHoverUnderline = styled(Bold)`
  color: ${colors.textPrimary};
  &:hover {
    text-decoration: underline;
  }
`;

export const StyledLoadingOverlay = styled(LoadingOverlay)`
  z-index: ${zIndex.loadingOverlay};
`;
